import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme-faces.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../node_modules/@fontsource-variable/besley/files/besley-latin-wght-normal.woff2%22,%22weight%22:%22400%20900%22,%22style%22:%22normal%22},{%22path%22:%22../../../node_modules/@fontsource-variable/besley/files/besley-latin-wght-italic.woff2%22,%22weight%22:%22400%20900%22,%22style%22:%22italic%22}],%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22Georgia%22,%22Times%20New%20Roman%22,%22serif%22],%22adjustFontFallback%22:%22Times%20New%20Roman%22}],%22variableName%22:%22besley%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'besley', 'besley Fallback', Georgia, Times New Roman, serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
